import { render, staticRenderFns } from "./DonorsTab.vue?vue&type=template&id=3a9ff8c0"
import script from "./DonorsTab.vue?vue&type=script&lang=ts"
export * from "./DonorsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports